import { listAnatomy } from '@chakra-ui/react/anatomy';
import { defineSlotRecipe } from '@chakra-ui/react/styled-system';

const listSlotRecipe = defineSlotRecipe({
  className: 'list',
  slots: listAnatomy.keys(),
  base: {
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8',
    },
    item: {
      alignItems: 'flex-start',
      display: 'inline-flex',
      whiteSpace: 'normal',
    },
    indicator: {
      alignItems: 'center',
      color: 'text/secondary',
      display: 'inline-flex',
      flexShrink: 0,
      justifyContent: 'center',
    },
  },
  variants: {
    size: {
      lg: {
        item: {
          textStyle: 'body/lg/regular',
        },
        indicator: {
          height: '24',
          width: '24',
        },
      },
      md: {
        item: {
          textStyle: 'body/md/regular',
        },
        indicator: {
          height: '20',
          width: '20',
        },
      },
      sm: {
        item: {
          textStyle: 'body/sm/regular',
        },
        indicator: {
          height: '16',
          width: '16',
        },
      },
    },
  },
  defaultVariants: {
    size: 'lg',
  },
});

export default listSlotRecipe;
